import React from 'react';
import { IconAlertCircle } from '@tabler/icons-react';
import Button from './Button';

export function Spinner() {
  return <div className="spinner" role="status" aria-label="Loading" />;
}

export function Skeleton({ height = 96, count = 1, gap = 12 }) {
  return (
    <div style={{ display: 'grid', gap }}>
      {Array.from({ length: count }, (_, i) => <div key={i} className="skeleton" style={{ height }} />)}
    </div>
  );
}

export function EmptyState({ icon, title, children, action }) {
  return (
    <div className="empty">
      {icon && <span className="empty__icon">{icon}</span>}
      {title && <p className="empty__title">{title}</p>}
      {children && <p>{children}</p>}
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}

export function ErrorState({ error, onRetry }) {
  return (
    <EmptyState
      icon={<IconAlertCircle size={26} />}
      title="Couldn’t load this"
      action={onRetry && <Button variant="outline" size="sm" onClick={onRetry}>Try again</Button>}
    >
      {error?.message || 'Please check your connection and try again.'}
    </EmptyState>
  );
}
